import login from './module';

export default login();
